// Module
var code = `<div class="HOA-card-flex-container HOA-card-flex--wrap">
    <div [ngClass]="{ 'is-invalid': invalidObj.line1Error }" class="Field HOA-card-flex-offset-child-left">
        <label tid="address1Label" id="address1Label" for="line1" class="Field-label">
            Address Line 1
            <span class="asterisk-required">&nbsp;&#42;</span>
        </label>
        <input type="text" app-allow-pattern allowPattern="\\d|-|[a-zA-Z]|/|#|\\s"
               (focus)="addressFocusObj.line1 = true"
               class="Input"
               id="line1" tid="line1" name="line1" maxlength="100" (change)="line1()" (blur)="blurFunction.emit();"
               [(ngModel)]="property.address.line1" [disabled]="disableInputsAddress" required
               aria-invalid="invalidObj.line1Error"
               attr.aria-describedby="{{invalidObj.line1Error && 'line1-error' || undefined }}">
        <span class="Field-error" tid="line1-error" id="line1-error">{{invalidObj.line1Msg}}</span>
    </div>
    <div [ngClass]="{ 'is-invalid': invalidObj.unitNumberError }"
         class="Field HOA-card-flex-offset-child-right HOA-card-has-details">
        <label tid="unitNumberLabel" id="unitNumberLabel" for="unitNumber" class="Field-label">Unit #</label>
        <input type="text" placeholder="(optional)"
               app-allow-pattern allowPattern="\\d|-|[a-zA-Z]|/|#|\\s"
               id="unitNumber"
               name="unitNumber" class="Input" tid="unitNumber" maxlength="100"
               [(ngModel)]="property.address.unit" (change)="unitNumber()" (blur)="blurFunction.emit()"
               [disabled]="disableInputsAddress"/>
    </div>
    <div [ngClass]="{ 'is-invalid': invalidObj.line2Error }"
         class="Field HOA-card-flex-child-100 HOA-card-flex-offset-child-left">
        <label tid="address2Label" id="address2Label" for="Address2" class="Field-label">Address Line 2</label>
        <input type="text" placeholder="(optional)"
               app-allow-pattern allowPattern="\\d|-|[a-zA-Z]|/|#|\\s"
               id="Address2" name="line2"
               class="Input" tid="line2" maxlength="100" [(ngModel)]="property.address.line2" (change)="line2()"
               (blur)="blurFunction.emit()" [disabled]="disableInputsAddress"/>
    </div>
</div>

<div class="HOA-card-flex-container">
    <div [ngClass]="{ 'is-invalid': invalidObj.cityError }" class="Field HOA-card-flex-offset-child-left">
        <label tid="cityLabel" id="cityLabel" for="city" class="Field-label">
            City
            <span class="asterisk-required">&nbsp;&#42;</span>
        </label>
        <input type="text"
               app-allow-pattern allowPattern="\\d|-|[a-zA-Z]|/|#|\\s"
               (focus)="addressFocusObj.city = true" class="Input"
               id="city" tid="city" name="city" maxlength="100" [(ngModel)]="property.address.city"
               (change)="city(); blurFunction.emit()"
               [disabled]="disableInputsAddress" required aria-invalid="invalidObj.cityError"
               attr.aria-describedby="{{invalidObj.cityError && 'city-error' || undefined }}">
        <span class="Field-error" tid="city-error" id="city-error">Please enter your property city.</span>
    </div>
    <div class="HOA-card-sub-flex-container">
        <div [ngClass]="{ 'is-invalid': invalidObj.stateError }"
             class="Field HOA-card-flex-offset-child-right HOA-card-pR1">
            <label tid="stateLabel" id="stateLabel" class="Field-label" for="State">
                State {{showCountry ? "/ Province" : ""}}
                <span class="asterisk-required">&nbsp;&#42;</span>
            </label>
            <div class="Select Select--State">
                <select id="State" tid="state" [(ngModel)]="property.address.state"
                        (focus)="addressFocusObj.state = true" (change)="state()" (blur)="blurFunction.emit()"
                        [disabled]="disableInputsAddress" required aria-invalid="invalidObj.stateError"
                        attr.aria-describedby="{{invalidObj.stateError && 'state-error' || undefined }}">
                    <option *ngFor="let state of states" [ngValue]="state.code">{{state.code}}</option>
                </select>
                <span class="Select-arrow"></span>
            </div>
            <span tid="state-error" id="state-error" class="Field-error">Please select a state.</span>
        </div>
        <div [ngClass]="{ 'is-invalid': invalidObj.zipCodeError }"
             class="Field HOA-card-flex-offset-child-right HOA-card-pL1">
            <label tid="zipCodeLabel" id="zipCodeLabel" for="zipCode" class="Field-label">
                Zip {{showCountry ? "/ Postal Code" : " Code"}}
                <span class="asterisk-required">&nbsp;&#42;</span>
            </label>
            <input type="text"
                   app-allow-pattern allowPattern="\\d"
                   (focus)="addressFocusObj.postalCode = true" class="Input"
                   id="zipCode" tid="zipCode" name="zipCode" maxlength="5"
                   [(ngModel)]="property.address.postalCode" (change)="zipCode(); blurFunction.emit()"
                   [disabled]="disableInputsAddress" required aria-invalid="invalidObj.zipCodeError"
                   attr.aria-describedby="{{invalidObj.zipCodeError && 'zipCode-error' || undefined }}">
            <span class="Field-error" tid="zipCode-error"
                  id="zipCode-error">{{invalidObj.zipCodeErrorMsg ? invalidObj.zipCodeErrorMsg : "Please enter your property zip" + (showCountry ? "/ postal" : "" + " code.")}}</span>
        </div>
    </div>
</div>
<div class="HOA-card-flex-container HOA-card-flex--wrap" *ngIf="showPropertyNickname">
    <div [ngClass]="{ 'is-invalid': invalidObj.propertyNicknameError }"
         class="Field HOA-card-flex-child-100 HOA-card-flex-offset-child-left">
        <label tid="propertyNicknameLabel" id="propertyNicknameLabel" for="propertyNickname"
               class="Field-label">
            Property Nickname
            <span class="asterisk-required">&nbsp;&#42;</span>
        </label>
        <input type="text" class="Input" id="propertyNickname" tid="propertyNickname" name="propertyNickname"
               maxlength="100" [(ngModel)]="property.nickname" (focus)="addressFocusObj.propertyNickname = true"
               (change)="propertyNickname()" required aria-invalid="invalidObj.propertyNicknameError"
               attr.aria-describedby="{{invalidObj.propertyNicknameError && 'propertyNickname-error' || undefined }}">
        <span class="Field-error" tid="propertyNickname-error" id="propertyNickname-error">Please enter a property nickname.</span>
    </div>
</div>
<div class="HOA-card-flex-container" *ngIf="showCountry">
    <div [ngClass]="{ 'is-invalid': invalidObj.countryError }" class="Field HOA-card-flex-offset-child-left">
        <label tid="countryLabel" id="countryLabel" class="Field-label" for="Country">Country</label>
        <div class="Select Select--State">
            <select id="Country" [(ngModel)]="selectedCountry" tid="country"
                    (focus)="addressFocusObj.country = true" [disabled]="disableInputsAddress"
                    aria-invalid="invalidObj.countryError"
                    attr.aria-describedby="{{invalidObj.countryError && 'Country-error' || undefined }}">
                <option *ngFor="let country of countryList" [ngValue]="country.abrev">{{country.name}}</option>
            </select>
            <span class="Select-arrow"></span>
        </div>
        <span tid="country-error" id="Country-error" class="Field-error">Please select a country.</span>
    </div>
    <div class="HOA-card-sub-flex-container">
        <div class="Field HOA-card-flex-offset-child-right HOA-card-pR1">
        </div>
        <div class="Field HOA-card-flex-offset-child-right HOA-card-pL1">
        </div>
    </div>
</div>`;
// Exports
module.exports = code;